import React, { useRef, useState } from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import usePermissions from '@afosto/utils-react/permissions/usePermissions';
import usePrivate from '@afosto/auth-react/usePrivate';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import SettingsProvider from '../../components/SettingsProvider';
import FulfilmentLocations from './FulfilmentLocations';
import GeneralSettings from './GeneralSettings';
import ShippingMethods from './ShippingMethods';
import Page from '@afosto/app-components-react/Page';
import translations from './translations';

const Settings = () => {
  usePrivate();
  const [hasPermissions] = usePermissions([
    'lcs:handling:read',
    'lcs:shipments:read',
    'lcs:shipments:write',
  ]);

  const history = useHistory();
  const intl = useIntl();
  const location = useLocation();
  const container = useRef(null);
  const [showNewLocationDrawer, setShowNewLocationDrawer] = useState(false);

  return (
    <SettingsProvider value={{ container, setShowNewLocationDrawer, showNewLocationDrawer }}>
      <Grid container wrap="nowrap">
        <Page
          title={intl.formatMessage(translations.title)}
          subNavigation={{
            current: location.pathname,
            tabs: [
              {
                label: intl.formatMessage(translations.subNavigation.general),
                path: '/settings',
              },
              {
                label: intl.formatMessage(translations.subNavigation.fulfilmentLocations),
                path: '/settings/fulfilment-locations',
              },
              {
                label: intl.formatMessage(translations.subNavigation.shippingMethods),
                path: '/settings/shipping-methods',
              },
            ],
            onChange: (e, value) => history.replace(value),
          }}
          primaryAction={
            location.pathname === '/settings/fulfilment-locations' &&
            hasPermissions(['lcs:locations:write'])
              ? {
                  text: intl.formatMessage(translations.createFulfilmentLocation.button),
                  action: () => setShowNewLocationDrawer(true),
                }
              : null
          }
          fullWidth
        >
          <Switch>
            <Route path="/settings/shipping-methods" component={ShippingMethods} />
            <Route path="/settings/fulfilment-locations" component={FulfilmentLocations} />
            <Route path="/settings" component={GeneralSettings} />
          </Switch>
        </Page>
        <div ref={container} />
      </Grid>
    </SettingsProvider>
  );
};

export default Settings;
